export default "__VITE_ASSET__QU5CMnnf__"